// mocks the config values for local development when local NAPI service is not available
const localDefaults = {
	BUGSNAG_CLIENT_ID: 'a364f63ff6217eb6e957d3d82cb76ecc', // NAPIC BUGSNAG
	FULLSTORY_ORG_ID: '99DEV',
	LAUNCHDARKLY_CLIENT_ID: '648753e6543074137a5584b3',
	DATADOG_RUM_APP_ID: '5f19919e-294d-4af3-8179-ad5e4b33a2c2',
	DATADOG_RUM_CLIENT_TOKEN: 'pub74c9d253cd6c7ea9e0a02223d0d0d91a',
	AUTODESK_PROFILE_ACCOUNT: 'https://profile-stg.autodesk.com/personalinfo',
	LEARN_MORE:
		'https://help-staging-beta.autodesk.com/view/BUILD/ENU/?contextId=Members_ACC_Profile',
	REGION: 'US',
	REMOTE_ASSETS_URL:
		'https://preview.acc-network-api-components.acc-qa.autodesk.com',
}

export default localDefaults
